export const URL_PARAM_TO_OBFUSCATE = '/callback?token=';
export const OBFUSCATE_STRING = '/callback?token=*****';
export const OBFUSCATE_BEARER_TOKEN = 'Bearer *****';
